import React, { useContext, useEffect, useState } from "react";
import Web3 from "web3";
import Staking from '../abi/Staking.json';
import Token from '../abi/Ptgc.json';
import UFOToken from '../abi/ufoToken/Ufo.json';
import UFOStaking from '../abi/ufoToken/Staking.json';
import { providerURL } from '../../../helper/Helper'; 

const Rewards = ({ptgcPrice, ufoPrice, plsPrice}) => {

  const [earnedFromHoldingPTGC, setEarnedFromHoldingPTGC] = useState(0);
  const [earnedFromStakingPTGC, setEarnedFromStakingPTGC] = useState(0);
  const [earnedFromLockingPTGC, setEarnedFromLockingPTGC] = useState(0);
  const [earnedFromHoldingUFO, setEarnedFromHoldingUFO] = useState(0);
  const [earnedFromLPingUFO, setEarnedFromLPingUFO] = useState(0);
  const [account, setAccount] = useState('');

  const getData = async () => {
    const web3 = new Web3(providerURL());

    if (web3.utils.isAddress(account)) 
    {
      const pTGCStakeContract = new web3.eth.Contract(Staking.ABI, Staking.Contract);
      const pTGCContract = new web3.eth.Contract(Token.ABI, Token.Contract);

      const UFOContract = new web3.eth.Contract(UFOToken.ABI, UFOToken.Contract);
      const UFOStakeContract = new web3.eth.Contract(UFOStaking.ABI, UFOStaking.Contract);

      let balanceOf = parseInt(await pTGCContract.methods.balanceOf(account).call()) / 10 ** 18;
      let totalReceived = parseInt(await pTGCContract.methods.totalReceived(account).call()) / 10 ** 18;
      let totalSend = parseInt(await pTGCContract.methods.totalSend(account).call()) / 10 ** 18;

      let earnedFromStakingPTGC = parseInt((await pTGCStakeContract.methods.mapUserInfo(account).call()).claimed) / 10 ** 18;
      let earnedFromLockingPTGC = parseInt((await pTGCStakeContract.methods.mapUserInfo(account).call()).lockClaimed) / 10 ** 18;
      let earnedFromHoldingPTGC = parseInt(0);

      if ((totalReceived + balanceOf) > totalSend) 
      {
        earnedFromHoldingPTGC = (totalSend + balanceOf) - totalReceived;
      }
      setEarnedFromHoldingPTGC(earnedFromHoldingPTGC);
      setEarnedFromStakingPTGC(earnedFromStakingPTGC);
      setEarnedFromLockingPTGC(earnedFromLockingPTGC);

      let totalReceivedUFO = parseInt(await UFOContract.methods.totalReceived(account).call()) / 10 ** 18;
      let totalSendUFO = parseInt(await UFOContract.methods.totalSend(account).call()) / 10 ** 18;
      let balanceOfUFO = parseInt(await UFOContract.methods.balanceOf(account).call()) / 10 ** 18;

      var earnedFromHoldingUFO = parseInt(0);
      if((totalReceivedUFO + balanceOfUFO) > totalSendUFO) 
      {
        earnedFromHoldingUFO = (totalSendUFO + balanceOfUFO) - (totalReceivedUFO); 
      }
      setEarnedFromHoldingUFO(earnedFromHoldingUFO);

      let earnedFromLPingUF0 = parseInt(await UFOStakeContract.methods.claimedReward(account).call()) / 10**18;
      setEarnedFromLPingUFO(earnedFromLPingUF0);
    } 
    else 
    {
      setEarnedFromHoldingPTGC(0);
      setEarnedFromStakingPTGC(0);
      setEarnedFromLockingPTGC(0);
      setEarnedFromHoldingUFO(0);
      setEarnedFromLPingUFO(0);
    }
  }

  return (
  <section className="RewardsSec excoSystemSec stakeSec  leftrightSecSpace">
      <div className="container">
          <div className="subcontent greysubcontent subPad SRTOP p-0">
              <div className="dateEco">

                  <div className="row justify-content-between ">
                      <div className="col-lg-12">
                          <h2 className="goldFont mb-0">Rewards</h2>
                          <div className="row justify-content-between ">
                              <div className="col-lg-12">
                                  <div className="CalculatorTop mt-2">
                                      <span className="fInter mb-1 d-block">Wallet Address:</span>
                                      <div className='inputIconSearch'>
                                          <input className="input w-100" placeholder="0xf5A89A6487D62df5308CDDA89c566C5B5ef94C11" type="text" value={account} onChange={(e) => setAccount(e.target.value)}/>
                                          <button className="nobg IconSearch" onClick={() => getData()}><i className="fa-solid fa-magnifying-glass"></i></button>
                                      </div>
                                  </div>
                              </div>
                          </div>
                      </div>
                      <div className="col-lg-12">
                          <div className="tarnsaGold statsALL">
                              <div className="PTGC-fee-allocation">
                                  <div className="topcards  mb-0 mt-4 p-0" style={{ border: '0px' }}>
                                      <div className="row">
                                        
                                          <div className='col-lg-4'>
                                              <div className="freesMulti">
                                                  <div className="card-label fInter">PTGC Earned From Holding</div>
                                                  <div className="f28 mt-0">
                                                    <h4 className="dollorValue value mb-0"><span>{parseFloat(earnedFromHoldingPTGC).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span><span className="dollor2">PTGC</span></h4>
                                                    <div className="perVal fInter d-flex align-items-center flex-wrap"><span>${parseFloat(earnedFromHoldingPTGC * ptgcPrice).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span></div>
                                                  </div>
                                              </div>
                                          </div>

                                          <div className='col-lg-4'>
                                              <div className="freesMulti">
                                                  <div className="card-label fInter">PTGC Earned From Staking</div>
                                                  <div className="f28 mt-0">
                                                    <h4 className="dollorValue value mb-0"><span>{parseFloat(earnedFromStakingPTGC).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span><span className="dollor2">PTGC</span></h4>
                                                    <div className="perVal fInter d-flex align-items-center flex-wrap"><span>${parseFloat(earnedFromStakingPTGC * ptgcPrice).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span></div>
                                                  </div>
                                              </div>
                                          </div>

                                          <div className='col-lg-4'>
                                              <div className="freesMulti">
                                                  <div className="card-label fInter">PTGC Earned From Locking</div>
                                                  <div className="f28 mt-0">
                                                    <h4 className="dollorValue value mb-0"><span>{parseFloat(earnedFromLockingPTGC).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span><span className="dollor2">PTGC</span></h4>
                                                    <div className="perVal fInter d-flex align-items-center flex-wrap"><span>${parseFloat(earnedFromLockingPTGC * ptgcPrice).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span></div>
                                                  </div>
                                              </div>
                                          </div>

                                          <div className='col-lg-4'>
                                              <div className="freesMulti">
                                                  <div className="card-label fInter">UFO Earned From Holding</div>
                                                  <div className="f28 mt-0">
                                                    <h4 className="dollorValue value mb-0"><span>{parseFloat(earnedFromHoldingUFO).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span><span className="dollor2">UFO</span></h4>
                                                    <div className="perVal fInter d-flex align-items-center flex-wrap"><span>${parseFloat(earnedFromHoldingUFO * ufoPrice).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span></div>
                                                  </div>
                                              </div>
                                          </div>

                                          <div className='col-lg-4'>
                                              <div className="freesMulti">
                                                  <div className="card-label fInter">PLS Earned From LPing</div>
                                                  <div className="f28 mt-0">
                                                    <h4 className="dollorValue value mb-0"><span>{parseFloat(earnedFromLPingUFO).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span><span className="dollor2">PLS</span></h4>
                                                    <div className="perVal fInter d-flex align-items-center flex-wrap"><span>${parseFloat(earnedFromLPingUFO * plsPrice).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span></div>
                                                  </div>
                                              </div>
                                          </div>
                                        
                                          <div className='col-lg-4'>
                                              <div className="freesMulti">
                                                  <div className="card-label fInter textgreen">Total Earned</div>
                                                  <div className="dollorVal f34 mt-2 d-inline-block">
                                                      <span className="dollor">$</span>
                                                      <span className="val f34">{parseFloat((earnedFromHoldingPTGC * ptgcPrice) + (earnedFromStakingPTGC * ptgcPrice) + (earnedFromLockingPTGC * ptgcPrice) + (earnedFromHoldingUFO * ufoPrice) + (earnedFromLPingUFO * plsPrice)).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                                                  </div>
                                              </div>
                                          </div>
                                      </div>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
  </section>
  );
};

export default Rewards;
